import FluidLayout from "@/layout/FluidLayout.vue";

export const homeRoutes = [
  // rwa
  {
    path: "/rwa",
    component: FluidLayout,
    redirect: "/rwa",
    meta: {
      title: "RWA",
      isShowCal: false,
    },
    children: [
      {
        path: "/rwa",
        name: "rwa",
        meta: {
          title: "天晟-RWA",
          isShowCal: false,
        },
        components: {
          default: () => import("@/views/modules/rwa/index.vue"),
        },
      },
    ],
  },
  // 云服务产品
  {
    path: "cloud",
    component: FluidLayout,
    redirect: "cloud",
    meta: {
      title: "cloud",
      isShowCal: false,
    },
    children: [
      {
        path: "/cloud",
        name: "cloud",
        meta: {
          title: "天晟-云服务产品",
          isShowCal: false,
        },
        components: {
          default: () => import("@/views/modules/cloud/index.vue"),
        },
      },
    ],
  },
  // 产品
  {
    path: "/product",
    component: FluidLayout,
    redirect: "/product",
    meta: {
      title: "product",
    },
    children: [
      {
        path: "/product",
        name: "product",
        meta: {
          title: "天晟-产品",
        },
        components: {
          default: () => import("@/views/modules/product/index.vue"),
        },
      },
      // {
      //   path: "/recommendindex",
      //   name: "recommendindex",
      //   meta: {
      //     title: "天晟-推荐产品",
      //     isShowCal: true,
      //   },
      //   components: {
      //     default: () =>
      //       import("@/views/modules/product/recommendindex/index.vue"),
      //   },
      // },
      {
        path: "/product/:id",
        name: "product_details",
        meta: {
          title: "天晟-产品详情",
        },
        components: {
          default: () => import("@/views/modules/components/GuidePage.vue"),
        },
      },
      {
        path: "/single-product/:id",
        name: "single_product_details",
        meta: {
          title: "天晟-产品详情",
        },
        components: {
          default: () => import("@/views/modules/components/SinglePage.vue"),
        },
      },
      {
        path: "/product/:id/order",
        name: "product_order",
        meta: {
          title: "天晟-产品订单",
        },
        components: {
          default: () =>
            import("@/views/modules/components/GuideOrderPage.vue"),
        },
      },
      {
        path: "/product/pay/:id",
        name: "product_pay",
        meta: {
          title: "天晟-产品支付",
        },
        components: {
          default: () => import("@/views/modules/components/GuidePayPage.vue"),
        },
      },
      {
        path: "/product/payment/success",
        name: "product_success",
        meta: {
          title: "天晟-支付成功",
        },
        components: {
          default: () =>
            import("@/views/modules/components/GuidePaySuccessPage.vue"),
        },
      },
    ],
  },
  // 联系我们
  {
    path: "/contact",
    component: FluidLayout,
    redirect: "/contact",
    meta: {
      title: "contact",
    },
    children: [
      {
        path: "/contact",
        name: "contact",
        meta: {
          title: "天晟-联系我们",
        },
        components: {
          default: () => import("@/views/modules/contact/index.vue"),
        },
      },
    ],
  },
  // 文档
  {
    path: "/document",
    component: FluidLayout,
    redirect: "/document",
    meta: {
      title: "document",
    },
    children: [
      {
        path: "/document",
        name: "document",
        meta: {
          title: "天晟-文档",
        },
        components: {
          default: () => import("@/views/modules/document/index.vue"),
        },
      },
      {
        path: "/document/:id",
        name: "documentDetail",
        meta: {
          title: "天晟-文档详情",
        },
        components: {
          default: () => import("@/views/modules/components/GuideArtcle.vue"),
        },
      },
    ],
  },
  // 解决方案
  {
    path: "/solution",
    component: FluidLayout,
    redirect: "/solution",
    meta: {
      title: "solution",
    },
    children: [
      {
        path: "/solution",
        name: "solution",
        meta: {
          title: "天晟-解决方案",
        },
        components: {
          default: () => import("@/views/modules/solution/index.vue"),
        },
      },
      {
        path: "/solution/:id",
        name: "solution_details",
        meta: {
          title: "天晟-方案详情",
        },
        components: {
          default: () => import("@/views/modules/solution/DetailSouView.vue"),
        },
      },
    ],
  },

  // Dapp商店
  {
    path: "/dapp-shop",
    component: FluidLayout,
    redirect: "/dapp-shop",
    meta: {
      title: "/dapp-shop",
    },
    children: [
      {
        path: "/dapp-shop",
        name: "dapp-shop",
        meta: {
          title: "天晟-案例库",
        },
        components: {
          default: () => import("@/views/modules/dapp-shop/index.vue"),
        },
      },
      {
        path: "/dapp-detail/:id",
        name: "dapp-detail",
        meta: {
          title: "天晟-案例库详情",
        },
        components: {
          default: () => import("@/views/modules/dapp-shop/dapp-detail.vue"),
        },
      },
    ],
  },
  // 解决方
  // 了解天晟
  {
    path: "/company",
    component: FluidLayout,
    redirect: "/company",
    meta: {
      title: "company",
    },
    children: [
      {
        path: "/company",
        name: "company",
        meta: {
          title: "了解天晟",
          isShowCal: true,
        },
        components: {
          default: () => import("@/views/modules/company/index.vue"),
        },
      },
    ],
  },
  // 最新动态
  {
    path: "/dynamics",
    component: FluidLayout,
    redirect: "/dynamics",
    meta: {
      title: "dynamics",
    },
    children: [
      {
        path: "/dynamics",
        name: "dynamics",
        meta: {
          title: "天晟-最新动态",
        },
        components: {
          default: () => import("@/views/modules/dynamics/index.vue"),
        },
      },
      {
        path: "/dynamics/:id",
        name: "dynamicsDetail",
        meta: {
          title: "天晟-动态详情",
        },
        components: {
          default: () => import("@/views/modules/dynamics/detail.vue"),
        },
      },
    ],
  },
  // 支持与服务
  {
    path: "/supportAndServices",
    component: FluidLayout,
    redirect: "/supportAndServices/Feedback",
    meta: {
      title: "supportAndServices",
    },
    children: [
      {
        path: "Feedback",
        name: "Feedback",
        meta: {
          title: "天晟-问题反馈",
        },
        components: {
          default: () =>
            import("@/views/modules/supportAndServices/Feedback.vue"),
        },
      },
      {
        path: "Service",
        name: "Service",
        meta: {
          title: "天晟-在线客服",
        },
        components: {
          default: () =>
            import("@/views/modules/supportAndServices/Service.vue"),
        },
      },
    ],
  },
  // 合作伙伴
  {
    path: "/partner",
    component: FluidLayout,
    redirect: "/partner",
    meta: {
      title: "partner",
    },
    children: [
      {
        path: "/partner",
        name: "partner",
        meta: {
          title: "天晟-合作伙伴",
        },
        components: {
          default: () => import("@/views/modules/partner/index.vue"),
        },
      },
      {
        path: "/become-partner",
        name: "become-partner",
        meta: {
          title: "天晟-合作申请",
        },
        components: {
          default: () => import("@/views/modules/partner/become-partner.vue"),
        },
      },
    ],
  },
  // BlockWatch宣传页
  {
    path: "/",
    component: FluidLayout,
    redirect: "/BlockWatch",
    meta: {
      title: "BlockWatch",
      isShowCal: false,
    },
    children: [
      {
        path: "/BlockWatch",
        name: "BlockWatch",
        meta: {
          title: "天晟-BlockWatch",
          isShowCal: false,
        },
        components: {
          default: () => import("@/views/modules/blockWatch/index.vue"),
        },
      },
    ],
  },
];
